module.exports = __webpack_public_path__ + "static/5-a1aeee385d6c2068023a4316bc0edaee.png";